import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PermissionCheck from "../components/PermissionCheck";
import QuestionPrompt from "../components/QuestionPromt";
import RecordingScreen from "../components/RecordingScreen";

const VideoRecordScreen = () => {
  const navigate = useNavigate();
  const webcamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const [cameraType, setCameraType] = useState("user");
  const [answer, setAnswer] = useState(null);
  const [initialAnswer, setInitialAnswer] = useState(null);
  const [allPermission, setAllPermission] = useState(true);
  const [recording, setRecording] = useState(false);
  const [videoChunks, setVideoChunks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [cameraAvailable, setCameraAvailable] = useState(true);
  const [localStream, setLocalStream] = useState(null);
  const [seconds, setSeconds] = useState(30);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const askCameraPermission = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        setLocalStream(stream);
        setCameraAvailable(true);
      } catch (error) {
        console.error("Error accessing the camera:", error);
      }
    };

    askCameraPermission();

    return () => {
      if (localStream) {
        localStream.getTracks().forEach((track) => track.stop());
      }
    };
  }, [localStream]);

  const startTimer = () => {
    if (isTimerActive) return;

    setSeconds(30);
    setIsTimerActive(true);
    timerRef.current = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          clearInterval(timerRef.current);
          setIsTimerActive(false);
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);
  };

  const handleStartCaptureClick = () => {
    if (webcamRef.current && webcamRef.current.stream) {
      setRecording(true);
      setVideoChunks([]);
      mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
        mimeType: "video/webm",
      });
      mediaRecorderRef.current.addEventListener(
        "dataavailable",
        handleDataAvailable
      );
      mediaRecorderRef.current.start();
    } else {
      console.error("Webcam stream is not available");
    }
  };

  const handleStopCaptureClick = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
  };

  const handleDataAvailable = ({ data }) => {
    if (data.size > 0) {
      setVideoChunks((prev) => [...prev, data]);
    }
  };

  useEffect(() => {
    if (!recording && videoChunks.length) {
      const videoBlob = new Blob(videoChunks, { type: "video/webm" });
      const videoURL = URL.createObjectURL(videoBlob);
      navigate("/view", { state: { uri: videoURL } });
    }
  }, [recording, videoChunks, navigate]);

  const handleRecord = () => {
    handleStartCaptureClick();
    startTimer();
  };

  const handleSubmit = () => {
    if (answer !== null) {
      setShowModal(true);
    } else {
      alert("Please select an answer.");
    }
  };

  const handleConfirm = () => {
    setInitialAnswer(answer);
    setTimeout(() => {
      // handleRecord();
    }, 1000);
    setShowModal(false);
  };

  const handleNext = () => {
    handleStopCaptureClick();
  };

  const handleGoBack = () => {
    navigate("/");
  };

  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return (
    <>
      <PermissionCheck
        allPermission={allPermission}
        setAllPermission={setAllPermission}
        cameraAvailable={cameraAvailable}
        handleGoBack={handleGoBack}
        styles={styles}
      />
      {initialAnswer === null ? (
        <QuestionPrompt
          question={question}
          setAnswer={setAnswer}
          handleSubmit={handleSubmit}
          showModal={showModal}
          setShowModal={setShowModal}
          handleConfirm={handleConfirm}
          styles={styles}
        />
      ) : (
        <RecordingScreen
          initialAnswer={initialAnswer}
          recording={recording}
          isTimerActive={isTimerActive}
          seconds={seconds}
          formattedSeconds={formattedSeconds}
          webcamRef={webcamRef}
          cameraType={cameraType}
          handleNext={handleNext}
          handleRecord={() => handleRecord()}
          styles={styles}
        />
      )}
    </>
  );
};

const question =
  "Do you have either spouse, parents, siblings, or children working as an advisor with ICICI Pru or any other insurance company?";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5",
  },
  centered: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "70%",
    margin: "auto",
    textAlign: "center",
  },
  radioGroup: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
  radioButton: {
    margin: "0 20px",
    fontSize: "18px",
    cursor: "pointer",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#3f51b5",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginTop: "20px",
  },
  text: {
    textAlign: "center",
    maxWidth: "80%",
  },
  buttonContainer: {
    textAlign: "center",
  },
  recordButton: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#3f51b5",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default VideoRecordScreen;
